import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

export interface UseAddAddressInformationStore {
  street1: string
  street2: string
  city: string
  state: string
  zipCode: string
}

interface AddressStore {
  userPrimaryAddress: UseAddAddressInformationStore | undefined
  setUserPrimaryAddress: (address: UseAddAddressInformationStore | undefined) => void
  userMailingAddress: UseAddAddressInformationStore | undefined
  setUserMailingAddress: (address: UseAddAddressInformationStore | undefined) => void
}

const useAddAddressInformationStore = create(
  persist<AddressStore>(
    (set) => ({
      userPrimaryAddress: undefined,
      setUserPrimaryAddress: (address: UseAddAddressInformationStore | undefined) =>
        set({ userPrimaryAddress: address }),
      userMailingAddress: undefined,
      setUserMailingAddress: (address: UseAddAddressInformationStore | undefined) =>
        set({ userMailingAddress: address }),
    }),
    {
      name: 'address-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)

export default useAddAddressInformationStore
